import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Search from './Search.vue'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/search-results',
      name: 'search-results',
      components: {
        default: Search,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true,
      },
      beforeEnter: allowOnlyAuthorized(),
      scrollBehavior () {
        return { x: 0, y: 0 }
      }
    },
  ])
}
